import { render, staticRenderFns } from "./merchantTypeConfig.vue?vue&type=template&id=7caf090b&scoped=true&"
import script from "./merchantTypeConfig.vue?vue&type=script&lang=ts&"
export * from "./merchantTypeConfig.vue?vue&type=script&lang=ts&"
import style0 from "./merchantTypeConfig.vue?vue&type=style&index=0&id=7caf090b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf090b",
  null
  
)

export default component.exports